"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const foundations_1 = require("@airstudio/foundations");
const actions = require("./actions");
exports.login = (dispatch) => {
    return async (jwt) => {
        dispatch(actions.loginRequest(jwt));
        try {
            const payload = await foundations_1.Api.setUpUser(jwt);
            dispatch(actions.loginSuccess(payload));
        }
        catch (error) {
            dispatch(actions.loginFailure(error.message || error));
            return false;
        }
        return true;
    };
};
exports.logout = (dispatch) => {
    return async () => {
        dispatch(actions.logoutRequest());
        try {
            dispatch(actions.logoutSuccess());
        }
        catch (e) {
            dispatch(actions.logoutFailure(e.message || e));
            return false;
        }
        return true;
    };
};
//# sourceMappingURL=operations.js.map